import React from 'react';
import Home from '../features/home';

const HomePage = () => {
  return <Home />;
};

export default HomePage;
